import React from 'react';
import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { QUICK_REACTIONS } from '../../../constants/messageConstants';

const ReactionBarContainer = styled(Box)(({ theme, isSelf, isVisible }) => ({
  position: 'absolute',
  top: { xs: '-32px', sm: '-36px' },
  [isSelf ? 'right' : 'left']: '0',
  display: { xs: 'none', sm: 'flex' }, // Hide on mobile, show on tablet and up
  gap: '4px',
  padding: { xs: '4px 6px', sm: '6px 8px' },
  background: alpha('#1a1a1a', 0.95),
  backdropFilter: 'blur(20px)',
  borderRadius: '20px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
  boxShadow: `0 4px 16px ${alpha('#000', 0.4)}`,
  opacity: isVisible ? 1 : 0,
  transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(4px) scale(0.95)',
  pointerEvents: isVisible ? 'auto' : 'none',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  zIndex: 10,
}));

const EmojiButton = styled(Box)(({ theme }) => ({
  width: { xs: '28px', sm: '32px' },
  height: { xs: '28px', sm: '32px' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: { xs: '16px', sm: '18px' },
  cursor: 'pointer',
  borderRadius: '50%',
  transition: 'all 0.15s ease',

  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.15),
    transform: 'scale(1.2)',
  },

  '&:active': {
    transform: 'scale(1.1)',
  },
}));

const ReactionBar = ({ isVisible, isSelf, onReact, messageId }) => {
  return (
    <ReactionBarContainer isVisible={isVisible} isSelf={isSelf}>
      {QUICK_REACTIONS.map((emoji) => (
        <EmojiButton
          key={emoji}
          onClick={(e) => {
            e.stopPropagation();
            onReact(messageId, emoji);
          }}
        >
          {emoji}
        </EmojiButton>
      ))}
    </ReactionBarContainer>
  );
};

export default ReactionBar;
